import React from "react";
import { observer } from "mobx-react-lite";
import { Col, CustomInput, Input, Row, UncontrolledTooltip } from "reactstrap";
import {  useIntl,FormattedMessage} from "react-intl";
import { validForBWRImageConfig } from "../../../../utils/common";
import { MODULE_WIDTH_CONSTRAINTS, SIZE_CONSTRAINTS, barcodeFormatConstants, BWR_CONSTRAINTS } from '../../../../utils/constants';

const ImageAndCharacteristicsView = observer(({ store, v1ImageConfig = {}, extendConfig = "{}", barcodeFormat }) => {
  const intl = useIntl();
  const isDataMatrix = barcodeFormat === barcodeFormatConstants.DATA_MATRIX;
  const isValid = validForBWRImageConfig(JSON.parse(extendConfig || '{}'), v1ImageConfig);
  if (!isValid && store.bwr !== 0) {
    store.forceInvalidateBwr();
  }
  // Get constraints based on current unit of measure
  const moduleWidthConstraint = MODULE_WIDTH_CONSTRAINTS[store.unitsOfMeasure] || MODULE_WIDTH_CONSTRAINTS.inch;
  const sizeConstraint = SIZE_CONSTRAINTS[store.unitsOfMeasure] || SIZE_CONSTRAINTS.inch;
  const bwrConstraint = BWR_CONSTRAINTS[store.unitsOfMeasure] || BWR_CONSTRAINTS.inch;

  return (
    <>
      <Row>
        <Col sm={3}>
          <FormattedMessage id="qrDesign.create.resolution.defaultMessage" />
        </Col>
        <Col sm={3}>
          <Input
            type="number"
            min="0"
            max="1200"
            id="resolution"
            value={store.resolution || ''}
            className="react-select-container"
            classNamePrefix="react-select"
            onChange={store.handleResolutionChange}
            onBlur={store.handleResolutionBlur}
            style={{width: "100%"}}
          >
          </Input>
        </Col>
        <Col sm={3}>
          {!store.isValidResolution && <p className="text-danger"><FormattedMessage id="qrDesign.create.validImageResolution.defaultMessage"/></p>}
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          {store.showImageSizeOrModuleWidth ? (
            <FormattedMessage id="qrDesign.create.imageSize.defaultMessage" />
          ) : (
            <FormattedMessage id="qrDesign.create.moduleWidth.defaultMessage" />
          )}
        </Col>
        <Col sm={3}>
          {store.showImageSizeOrModuleWidth ? (
            <Input
              type="number"
              min={sizeConstraint.min}
              max={sizeConstraint.max}
              step={sizeConstraint.step}
              id="size"
              value={store.size < 0 ? '' : store.size}
              className="react-select-container"
              classNamePrefix="react-select"
              onChange={store.handleSizeChange}
              onBlur={store.handleSizeBlur}
              style={{width: "100%"}}
            >
            </Input>
          ) : (
            <Input
              type="number"
              id="moduleWidth"
              value={store.moduleWidth < 0 ? '' : store.moduleWidth}
              min={moduleWidthConstraint.min}
              max={moduleWidthConstraint.max}
              step={moduleWidthConstraint.step}
              className="react-select-container"
              classNamePrefix="react-select"
              onChange={store.handleModuleWidthChange}
              onBlur={store.handleModuleWidthBlur}
              style={{width: "100%"}}
            >
            </Input>
          )}
        </Col>
        <Col sm={3}>
          <CustomInput
            type="switch"
            id="sizeDisplayToggle"
            name="sizeDisplayToggle"
            label={store.showImageSizeOrModuleWidth ? "Switch to Module Width" : "Switch to Image Size"}
            onChange={() => store.toggleSizeDisplay()}
          />
        </Col>
      </Row>
      
      {/*/////////////////////////// remove 'Select Format' till after deployment //////////////////////////////////*/}
      {/*<Row>*/}
      {/*  <Col sm={3}>*/}
      {/*    <FormattedMessage id="qrDesign.create.selectFormat.defaultMessage" />*/}
      {/*  </Col>*/}
      {/*  <Col sm={3}>*/}
      {/*    <CustomInput*/}
      {/*      type="select"*/}
      {/*      id="imageFormat"*/}
      {/*      value={store.imageFormat}*/}
      {/*      className="react-select-container"*/}
      {/*      classNamePrefix="react-select"*/}
      {/*      onChange={store.handleFormatSelect}*/}
      {/*    >*/}
      {/*      <option value="png">{intl.formatMessage({ id: 'qrDesign.create.selectFormatOptions.PNG.defaultMessage' })}</option>*/}
      {/*      <option value="jpg">{intl.formatMessage({ id: 'qrDesign.create.selectFormatOptions.JPG.defaultMessage' })}</option>*/}
      {/*    </CustomInput>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      {/*//////////////////////////////////////////////////////////////////////////////////////////////////////////*/}

      <Row>
        <Col sm={3}>
          <FormattedMessage id="qrDesign.create.unitOfMeasures.defaultMessage" />
        </Col>
        <Col sm={3}>
          <CustomInput
            type="select"
            value={store.unitsOfMeasure}
            id="unitsOfMeasure"
            className="react-select-container"
            classNamePrefix="react-select"
            onChange={store.handleUnitOfMeasure}
          >
            <option value="inch">{intl.formatMessage({ id: 'qrDesign.create.unitOfMeasuresOptions.inch.defaultMessage' })}</option>
            <option value="cm">{intl.formatMessage({ id: 'qrDesign.create.unitOfMeasuresOptions.cm.defaultMessage' })}</option>
            <option value="mm">{intl.formatMessage({ id: 'qrDesign.create.unitOfMeasuresOptions.mm.defaultMessage' })}</option>
          </CustomInput>
        </Col>
      </Row>

      {/*<Row>*/}
      {/*  <Col sm={3}>*/}
      {/*    Advance Features*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row>
        {/*We don't support BWR yet but here is the element for the future*/}
        {/*<Col sm={3}>*/}
        {/*  BWR*/}
        {/*</Col>*/}
        {/*<Col sm={3}>*/}
        {/*  <Input*/}
        {/*    type="text"*/}
        {/*    id="bwr"*/}
        {/*    value={store.bwr}*/}
        {/*    onChange={store.handleBwr}*/}
        {/*  />*/}
        {/*</Col>*/}
      </Row>
      {!isDataMatrix && (
      <Row>
        <Col sm={3}>
          <FormattedMessage id="qrDesign.create.errorCorrection.defaultMessage" />
        </Col>
        <Col sm={3}>
          <CustomInput
            type="select"
            id="errorCorrection"
            value={store.errorCorrection}
            className="react-select-container"
            classNamePrefix="react-select"
            onChange={store.handleErrorCorrection}
          >
            <option value="L">{intl.formatMessage({ id: 'qrDesign.create.errorCorrectionOptions.L.defaultMessage' })}</option>
            <option value="M">{intl.formatMessage({ id: 'qrDesign.create.errorCorrectionOptions.M.defaultMessage' })}</option>
            <option value="Q">{intl.formatMessage({ id: 'qrDesign.create.errorCorrectionOptions.Q.defaultMessage' })}</option>
            <option value="H">{intl.formatMessage({ id: 'qrDesign.create.errorCorrectionOptions.H.defaultMessage' })}</option>
          </CustomInput>
        </Col>
      </Row>
      )}
      <Row>
        <Col sm={3}> <FormattedMessage id="qrDesign.create.quietZone.defaultMessage" /></Col>
        <Col sm={3}>
          <CustomInput
            type="select"
            id="quietZone"
            value={store.quietZone}
            className="react-select-container"
            classNamePrefix="react-select"
            onChange={store.handleQuiteZone}
          >
            <option value={0}>0</option>
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
            <option value={5}>5</option>
            <option value={6}>6</option>
          </CustomInput>
        </Col>
        {/*<Col sm={2}>*/}
        {/*  <CustomInput*/}
        {/*    type="select"*/}
        {/*    className="react-select-container"*/}
        {/*    classNamePrefix="react-select">*/}
        {/*    <option value="">Modules</option>*/}
        {/*    <option>1</option>*/}
        {/*  </CustomInput>*/}
        {/*</Col>*/}
      </Row>
      <Row>
        <Col sm={3}> <FormattedMessage id="qrDesign.create.legacyDesgin.BWR.defaultMessage" /></Col>
        <Col sm={3}>
          <Input
            type="number"
            step={bwrConstraint.step}
            id="bwr"
            value={isValid ? store.bwr : 0}
            className="react-select-container"
            classNamePrefix="react-select"
            disabled={!isValid}
            onChange={store.handleBwrChange}
            onBlur={store.handleBwrBlur}
            style={{width: "100%"}}
          >
          </Input>
          {<UncontrolledTooltip target="bwr">0 (no BWR) or {bwrConstraint.min} – {bwrConstraint.max} {store.unitsOfMeasure}</UncontrolledTooltip>}
        </Col>
      </Row>
    </>
  )
})
export default ImageAndCharacteristicsView;
